document.addEventListener("DOMContentLoaded", function () {
  stickyControllerInit();
  closeModal();
  initStickyButtonObserver();
});

function initStickyButtonObserver() {
  const stickyTriggerButton = document.getElementById("buy-button-modal");
  const mainSubmitButton = document.querySelector(
    ".product__info-container .product-form__submit",
  );
  const scrollEvent = stickyTriggerButton.dataset.scrollEvent;

  if (!stickyTriggerButton || !mainSubmitButton || scrollEvent === "false")
    return;

  const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: "0px 0px 0px 0px",
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const isOffScreenTop =
        !entry.isIntersecting && entry.boundingClientRect.y < 0;

      if (isOffScreenTop) {
        stickyTriggerButton.setAttribute("data-visible", "true");
      } else {
        stickyTriggerButton.setAttribute("data-visible", "false");
      }
    });
  }, observerOptions);

  observer.observe(mainSubmitButton);
}

function stickyControllerInit() {
  const modal = document.getElementById("product-sticky-modal");
  const mainContainer = document.querySelector(".product__info-container");
  if (!modal || !mainContainer) return;

  const updateVisuals = (clickedInput) => {
    const name = clickedInput.name;
    const group = modal.querySelectorAll(`input[name="${name}"]`);

    group.forEach((input) => {
      const isTarget = input === clickedInput;

      input.checked = isTarget;
      if (isTarget) {
        input.setAttribute("checked", "checked");
      } else {
        input.removeAttribute("checked");
      }

      const planContainer =
        input.closest(".gosub-widget__plan-header") ||
        input.closest(".gosub-widget__fieldset") ||
        input.parentElement;
      if (planContainer) {
        const labels = planContainer.querySelectorAll(
          ".gosub-widget__plan-label",
        );
        labels.forEach((label) => {
          label.classList.toggle("active", isTarget);
        });
      }

      if (!input.closest(".gosub-widget__plan-label")) {
        const variantLabel = input.nextElementSibling;
        if (variantLabel && variantLabel.tagName === "LABEL") {
          variantLabel.classList.toggle("active", isTarget);
        }
      }
    });
  };

  modal.addEventListener("change", (e) => {
    const target = e.target;
    if (target.type !== "radio") return;

    updateVisuals(target);

    let mainInput;
    if (target.hasAttribute("data-modal-input")) {
      const variantId = target.value;
      const idInput = modal.querySelector("input.product-variant-id");
      if (idInput) idInput.value = variantId;

      mainInput = mainContainer.querySelector(`input[value="${variantId}"]`);
    } else {
      const selector = `[name="${target.name}"][value="${target.value}"]`;
      mainInput = mainContainer.querySelector(selector);
    }

    if (mainInput) {
      mainInput.click();

      setTimeout(() => updateVisuals(target), 10);
      setTimeout(() => updateVisuals(target), 100);
    }
  });

  const stickyQtyInput = modal.querySelector("quantity-input input");
  if (stickyQtyInput) {
    stickyQtyInput.addEventListener("change", (e) => {
      const mainQty = mainContainer.querySelector("quantity-input input");
      if (mainQty) {
        mainQty.value = e.target.value;
        mainQty.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
}

function closeModal() {
  const modal = document.getElementById("product-sticky-modal");
  const modalForm = modal.querySelector('form[id^="product-modal-form"]');
  if (!modalForm) return;

  modalForm.addEventListener("submit", () => {
    setTimeout(() => {
      if (modal.hidePopover) modal.hidePopover();
    }, 2000);
  });
}

window.dispatchMainClick = () => {
  const mainSubmitButton = document.querySelector(
    ".product__info-container .product-form__submit",
  );
  if (mainSubmitButton) {
    if (!mainSubmitButton.hasAttribute("disabled")) {
      mainSubmitButton.click();
    } else {
      alert("選択されたバリエーションは在庫がありません");
    }
  }
};
